import React, { useState } from 'react';
import { Button } from '../ui/button';
import FAQItem from './FAQItems';
import { useLocation } from 'react-router-dom';

export const FAQSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const location = useLocation();
  const pathname = location.pathname;

  const scrollToBookATour = () => {
    const element = document.getElementById('book-a-tour');
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const faqAffordablity = [
    {
      question: "What amenities are included in Offis Bay coworking plans?",
      answer: [
        "High-speed Wi-Fi internet",
        "Air conditioning",
        "Printing facilities",
        "Lounge access",
        "Complimentary refreshments",
        "Office supplies",
        "Event space access"
      ]
    },
    {
      question: "How does Offis Bay ensure security and privacy?",
      answer: [
        "24/7 CCTV surveillance",
        "Secure internet access control",
        "Professional reception staff",
        "Controlled building access",
        "Safe and secure working environment"
      ]
    },
    {
      question: "What startup support does Offis Bay provide?",
      answer: [
        "Partnerships with business incubators",
        "Legal and financial consultant connections",
        "Mentorship program access",
        "Business registration assistance",
        "Growth-focused networking events"
      ]
    },
    {
      question: "Are there long-term contract requirements?",
      answer: [
        "Daily, weekly, monthly, and yearly plans",
        "Scale up or down based on business needs",
        "No lock-in periods or binding lease agreements"
      ]
    },
    {
      question: "Does Offis Bay offer meeting and conference rooms?",
      answer: [
        "Presentation tools and AV equipment",
        "High-speed internet connectivity",
        "Professional ambiance",
        "Hourly and daily booking options",
        "Reception support services"
      ]
    }
  ];

const faqMeeting = [
  {
    question: "How can I book a meeting room at Offis Bay?",
    answer:
      "You can book a meeting room online through our website, via phone, or by visiting our reception at Offis Bay, Anna Salai. Instant booking options are available for members.",
  },
  {
    question: "What types of meeting rooms are available at Offis Bay?",
    answer:
      "Offis Bay offers a variety of meeting spaces including private meeting rooms, conference rooms, and boardrooms. Ideal for client meetings, team discussions, interviews, or workshops.",
  },
  {
    question: "What amenities are included?",
    answer: [
      "High-speed Wi-Fi",
      "Whiteboards and markers",
      "Projectors or LED screens",
      "Air conditioning and comfortable seating",
      "Complimentary beverages",
    ],
  },
  {
    question: "Can I book a meeting room by the hour or for the whole day?",
    answer:
      "Both! Offis Bay offers flexible booking options — hourly, half-day, and full-day packages. All depending on your needs.",
  },
  {
    question: "Are meeting rooms accessible to non-members?",
    answer:
      "Absolutely! Our meeting rooms are open to both Offis Bay members and external guests. Prior booking is recommended to ensure availability.",
  },
  {
    question: "Can I reschedule or cancel a meeting room booking?",
    answer:
      "Yes, you can reschedule or cancel with at least 24 hours’ notice to avoid any cancellation fees. Please refer to our cancellation policy for details.",
  },
];


  const faqDayPass = [
    {
      question: "Can I try Offis Bay coworking space before committing to a plan?",
      answer:
        "Yes! Offis Bay offers a free one-day demo experience for potential members. One person per day can visit and use our Chennai coworking space completely free. Experience our environment, amenities, and professional vibe before making your decision.",
    },
    {
      question: "How do I book my day pass at Offis Bay Chennai?",
      answer:
        "Simply contact our front desk or book through our website. Demo slots are first-come, first-served with only one user allowed per day. We recommend booking in advance to secure your spot.",
    },
    {
      question: "What amenities are included in the day pass?",
      answer: [
        "High-speed Wi-Fi internet",
        "Comfortable ergonomic seating",
        "Complimentary tea and coffee",
        "Air-conditioned workspace",
        "Shared common work zones",
      ],
    },
    {
      question: "Is the demo workspace private or shared?",
      answer:
        "The demo day takes place in our shared coworking area, allowing you to experience our vibrant professional community. You can view our private cabins during your visit for future rental consideration.",
    },
    {
      question: "Can I bring a guest during my day pass visit?",
      answer:
        "The day pass is limited to one person per day to ensure a fair and productive environment for all users. Guests are not permitted during demo visits.",
    },
  ];

  const faqVirtual = [
    {
      question: "What is a virtual office?",
      answer:
        "A virtual office provides you with a professional Chennai business address, mail handling services, and meeting room access, without renting a full-time physical workspace. It's perfect for remote businesses, freelancers, and startups seeking professional credibility.",
    },
    {
      question: "What documents do I need to get started?",
      answer: [
        "Company Name",
        "Registered Address of the company",
        "Representer/Authorized Personnel (Full Name as per Aadhar)",
        "Age of the representer",
        "Address of the representer",
        "Aadhar Number",
      ],
    },
    {
      question: "Can I register my company using Offis Bay's virtual office address in Chennai?",
      answer:
        "Yes! Offis Bay provides GST registration and business incorporation support with our virtual office plans. Our Chennai address is fully compliant for legal and professional business registration requirements.",
    },
    {
      question: "Can I upgrade from virtual office to physical coworking space later?",
      answer:
        "Absolutely! Start with our virtual office plan and seamlessly scale to shared desks or private cabins as your team grows. Our flexible plans accommodate your business evolution.",
    },
    {
      question: "Is Offis Bay suitable for remote teams and hybrid work?",
      answer:
        "Yes! Remote teams can utilize our virtual office services for professional business presence and book meeting spaces as needed, creating an effective hybrid work model.",
    },
    {
      question: "What are Offis Bay's coworking and virtual office pricing plans?",
      answer: [
        "Virtual office plans: Starting from ₹999/month",
        "Coworking desks: Starting from ₹199/day",
        "Flexible daily, weekly, monthly, and yearly options available",
      ],
    },
  ];

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const getFAQItems = () => {
    if (pathname === '/affordable-coworking-space') {
      return faqAffordablity;
    } else if (pathname === '/mount-road-chennai') {
      return faqAffordablity;
    } else if (pathname === '/virtual-office-chennai') {
      return faqVirtual;
    } else if (pathname === '/meeting-room') {
      return faqMeeting;
    } else if (pathname === '/free-day-pass') {
      return faqDayPass;
    }
    return faqAffordablity; // Default fallback
  };

  const faqItems = getFAQItems();

  return (
    <section className="flex w-[100vw] mb-16 gap-28 mx-auto my-0 pt-8 pb-0 px-16 max-md:flex-col max-md:gap-12 max-md:pt-8 max-md:pb-0 max-md:px-8 max-sm:gap-8 max-sm:pt-10 max-sm:pb-0 max-sm:px-5">
      <div className="w-[38%] shrink-0 left-[section] max-md:w-full max-md:max-w-none">
        <h2 className="text-[#966376] font-sans text-lg font-semibold leading-[27px] uppercase mb-3 max-sm:text-base">
          FREQUENTLY ASKED QUESTIONS
        </h2>
        <h3 className="text-[#0B2549] font-regrade text-5xl font-semibold leading-[57.6px] w-[455px] mb-6 max-md:w-full max-md:text-[40px] max-sm:text-[32px]">
          Still Wondering? Let us Clarify
        </h3>
        <div className="mt-3.5 relative">
          <Button onClick={scrollToBookATour} style={{ borderRadius: '30px' }} className="text-[15px] text-white rounded-[30px] mr-0 sm:mr-8 px-5 hover:bg-[#7d5262] transition-colors w-full sm:w-auto">
            Book A Tour
          </Button>
        </div>
      </div>
      <div className="flex-1 max-w-[62%] right-[section] max-md:max-w-none overflow-hidden">
        <div className="flex flex-col w-full">
          {faqItems.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isExpanded={expandedIndex === index}
              isFirst={index === 0}
              onToggle={() => handleToggle(index)}
            />
          ))}
          <div className="w-[136px] h-px bg-[#6D7E94]" />
        </div>
      </div>
    </section>
  );
};
